module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.site) ? _c('div', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "app-footer__subscribe is-hidden-tablet"
  }, [_c('subscribe-form')], 1), _vm._v(" "), _c('footer', {
    staticClass: "nimbus-sans underline-links"
  }, [_c('links', {
    staticClass: "is-hidden-mobile",
    attrs: {
      "links": this.site.data['site.footer_links_1'].value
    }
  }), _vm._v(" "), _c('links', {
    staticClass: "right is-hidden-mobile",
    attrs: {
      "links": this.site.data['site.footer_links_2'].value
    }
  }), _vm._v(" "), _c('links', {
    staticClass: "h8 is-hidden-tablet",
    attrs: {
      "links": this.site.data['site.footer_mobile_links_1'].value
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59bb6a67"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 388
// module chunks = 1